import { render, staticRenderFns } from "./massSend.vue?vue&type=template&id=047b183f&"
import script from "./massSend.vue?vue&type=script&lang=js&"
export * from "./massSend.vue?vue&type=script&lang=js&"
import style0 from "./massSend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports